import React from "react";
import { Box, Typography, Container, Divider } from "@mui/material";
import { ContactUsWrapper } from "./styles";
import { Instagram, Facebook, Email, Chat, LocationOn, Phone, WhatsApp } from "@mui/icons-material";
import PageConversion from "../../Components/PageConversion";
const ContactUs = () => {
	const handleChatSupport = () => {
		if ((window as any).tidioChatApi) {
			(window as any).tidioChatApi.open();
		}
	};
	return (
		<ContactUsWrapper>
			<Container>
				<Box display={"flex"} flexDirection={"column"} mt={6}>
					<Box display={"flex"} justifyContent={"center"}>
						<Typography variant={"h2"} fontWeight={"bold"} className={"title"}>
							Contact Us
						</Typography>
					</Box>
					<Box className={"sub-title-wrapper"}>
						<Typography className={"sub-title"}>
							Our support team is available 24/7 to assist you every step of the way—before and after you purchase.
						</Typography>
					</Box>
				</Box>
				<Box display={"flex"} justifyContent={"center"} flexWrap={"wrap"} gap={2} mt={8}>
					<a
						href="https://www.instagram.com/viteslink/"
						target={"_blank"}
						rel="noreferrer"
						className={"social_wrapper"}
					>
						<Box className={"social"}>
							<Instagram />
							<Typography>Instagram</Typography>
						</Box>
					</a>
					<a
						href="https://www.facebook.com/share/1DM6gnk2q7/"
						target={"_blank"}
						rel="noreferrer"
						className={"social_wrapper"}
					>
						<Box className={"social"}>
							<Facebook />
							<Typography>Facebook</Typography>
						</Box>
					</a>
					<a href="mailto:info@viteslink.com" target={"_blank"} rel="noreferrer" className={"social_wrapper"}>
						<Box className={"social"}>
							<Email />
							<Typography>Email</Typography>
						</Box>
					</a>

					<a href="https://wa.me/201104065253" target="_blank" rel="noreferrer" className="social_wrapper">
						<Box className={"social"}>
							<WhatsApp />
							<Typography>WhatsApp</Typography>
						</Box>
					</a>
					<Box onClick={handleChatSupport} className={"social_wrapper"}>
						<Box className={"social"}>
							<Chat />
							<Typography>Chat Support</Typography>
						</Box>
					</Box>
				</Box>
				<Box display={"flex"} justifyContent={"center"} flexWrap={"wrap"} gap={4} mt={6}>
					<Box display={"flex"} alignItems={"center"} gap={1} className={"info_item"}>
						<LocationOn className={"info_icon"} />
						<Typography className={"info_text"}>Cairo, Egypt</Typography>
					</Box>
					<Box
						display={"flex"}
						alignItems={"center"}
						gap={1}
						className={"info_item"}
						component={"a"}
						href="https://wa.me/201104065253"
						target="_blank"
						rel="noreferrer"
					>
						<WhatsApp className={"info_icon"} />
						<Typography className={"info_text"}>+20 110 406 5253</Typography>
					</Box>
					<Box
						href="mailto:info@viteslink.com"
						component={"a"}
						target={"_blank"}
						rel="noreferrer"
						display={"flex"}
						alignItems={"center"}
						gap={1}
						className={"info_item"}
					>
						<Email className={"info_icon"} />
						<Typography className={"info_text"}>info@viteslink.com</Typography>
					</Box>
				</Box>
				<Box my={6}>
					<Divider />
				</Box>
				<PageConversion />
			</Container>
		</ContactUsWrapper>
	);
};

export default ContactUs;
